<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="parentId" >
        <span slot="label" >
          <a-tooltip>
            父评论id<template slot="title">父评论id</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.parentId"  :placeholder="$t('请输入')+'父评论id'" />
      </a-form-model-item>
      <a-form-model-item prop="postId" >
        <span slot="label" >
          <a-tooltip>
            文章id<template slot="title">文章id</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.postId"  :placeholder="$t('请输入')+'文章id'" />
      </a-form-model-item>
      <a-form-model-item prop="commentUserId" >
        <span slot="label" >
          <a-tooltip>
            用户ID<template slot="title">用户ID</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.commentUserId"  :placeholder="$t('请输入')+'用户ID'" />
      </a-form-model-item>
      <a-form-model-item prop="commentUserAvatar" >
        <span slot="label" >
          <a-tooltip>
            评论用户头像<template slot="title">评论用户头像</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.commentUserAvatar" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item prop="commentUserName" >
        <span slot="label" >
          <a-tooltip>
            评论用户昵称<template slot="title">评论用户昵称</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.commentUserName" :maxLength="100" :placeholder="$t('请输入')+'评论用户昵称'" />
      </a-form-model-item>
      <a-form-model-item prop="content" >
        <span slot="label" >
          <a-tooltip>
            评论内容<template slot="title">评论内容</template>
          </a-tooltip>
        </span>
        <editor v-model="form.content" />
      </a-form-model-item>
      <a-form-model-item prop="isAuthorComment" >
        <span slot="label" >
          <a-tooltip>
            是否作者评论：1-是，0-否<template slot="title">是否作者评论：1-是，0-否</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.isAuthorComment"  :placeholder="$t('请输入')+'是否作者评论：1-是，0-否'" />
      </a-form-model-item>
      <a-form-model-item prop="remark" >
        <span slot="label" >
          <a-tooltip>
            备注<template slot="title">备注</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getDiscoveryComment, addDiscoveryComment, updateDiscoveryComment } from '@/api/discovery/discoveryComment'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";

import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
    Editor
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        parentId: null,

        postId: null,

        commentUserId: null,

        commentUserAvatar: null,

        commentUserName: null,

        content: null,

        isAuthorComment: null,

        createTime: null,
        localeFieldMap:{},

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        postId: [
          { required: true, message: '文章id'+this.$t('不能为空'), trigger: 'blur' }
        ],
        commentUserId: [
          { required: true, message: '用户ID'+this.$t('不能为空'), trigger: 'blur' }
        ],
        commentUserName: [
          { required: true, message: '评论用户昵称'+this.$t('不能为空'), trigger: 'blur' }
        ],
        content: [
          { required: true, message: '评论内容'+this.$t('不能为空'), trigger: 'blur' }
        ],
        isAuthorComment: [
          { required: true, message: '是否作者评论：1-是，0-否'+this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        parentId: null,
        postId: null,
        commentUserId: null,
        commentUserAvatar: null,
        commentUserName: null,
        content: null,
        isAuthorComment: null,
        createTime: null,
        localeFieldMap:{},
        remark: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getDiscoveryComment({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateDiscoveryComment(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addDiscoveryComment(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
